import { InitAdapter, SubmitAdapter } from '../../types';

export const initAdapter: InitAdapter = (
  { inTiers = [], tiers = [] },
  { tierId }
) => {
  return tiers.map(tier => ({
    value: tier.deviationId,
    label: tier.title,
    selected:
      inTiers.some(g => g.deviationId === tier.deviationId) ||
      tier.deviationId === tierId,
  }));
};

type MultiselectItem = { selected: boolean; value: number; label: string };
function filterToSelectedInts(items: MultiselectItem[] = []): number[] {
  const selected: number[] = [];
  for (const item of items) {
    if (item.selected) {
      selected.push(parseInt(String(item.value), 10));
    }
  }
  return selected;
}

export const submitAdapter: SubmitAdapter = ({ tiers = [] }) => ({
  tierids: filterToSelectedInts(tiers),
});
